var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9109",
    "data-name": "Group 9109",
    transform: "translate(0 0.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1651",
    "data-name": "Ellipse 1651",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(0 -0.404)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "suitcase",
    transform: "translate(20.825 23.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9120",
    "data-name": "Group 9120",
    transform: "translate(0.037 8.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19683",
    "data-name": "Path 19683",
    d: "M56.692,53.482H6.592C2.9,53.482,0,50.345,0,46.352V12.13C0,8.137,2.9,5,6.592,5h50.1c3.692,0,6.592,3.137,6.592,7.13V46.352C63.284,50.345,60.383,53.482,56.692,53.482ZM6.592,7.852A4.231,4.231,0,0,0,2.637,12.13V46.352A4.231,4.231,0,0,0,6.592,50.63h50.1a4.231,4.231,0,0,0,3.955-4.278V12.13a4.231,4.231,0,0,0-3.955-4.278Z",
    transform: "translate(0 -5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9121",
    "data-name": "Group 9121",
    transform: "translate(21.845 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19684",
    "data-name": "Path 19684",
    d: "M24.564,11.865a1.109,1.109,0,0,1-1.1-1.233V5.7a1.109,1.109,0,0,0-1.1-1.233H11.313a1.109,1.109,0,0,0-1.1,1.233v4.932a1.111,1.111,0,1,1-2.209,0V5.7A3.612,3.612,0,0,1,11.313,2H22.356a3.612,3.612,0,0,1,3.313,3.7v4.932A1.109,1.109,0,0,1,24.564,11.865Z",
    transform: "translate(-8 -2)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9122",
    "data-name": "Group 9122",
    transform: "translate(0 25.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19685",
    "data-name": "Path 19685",
    d: "M31.708,16.062H31.18L.835,10.425C.307,10.284-.22,9.861.044,9.438a2.3,2.3,0,0,1,1.847-.423l29.817,5.637L61.525,9.015q1.187-.211,1.583.423t-.792.846L31.971,15.921c0,.141,0,.141-.264.141Z",
    transform: "translate(0.027 -8.963)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience);
export default __webpack_public_path__ + "static/media/WorkExperience.a7a313f8f80b68c3f3ba70f4ac869a71.svg";
export { ForwardRef as ReactComponent };